import { GET_POOL_STATUS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_POOL_STATUS:
      return action.payload;
    default:
      return state;
  }
};
